import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";

import BackgroundImage from "../../assets/images/visual_members.jpg";
import MobileSubVisual from "../../components/mobile/MobileSubVisual";
import MobileMemberDetailModal from "../../components/mobile/MobileMemberDetailModal";
import MemberListSection from "../../components/MemberListSection";

const MainContent = styled.section`
  max-width: 100%;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 60px 16px;
`;

export function Members() {
  const [activeMenu, setActiveMenu] = useState("전체보기");

  const navigate = useNavigate();

  const menuList = useMemo(() => ["전체보기", "본점", "구로분실", "강남분실", "광주지점"], []);

  const [searchParams, setSearchParams] = useSearchParams();

  const handleMenuClick = (menu) => {
    setSearchParams({ menu });
    setActiveMenu(menu);
  }

  useEffect(() => {
    const menu = searchParams.get("menu");

    if (!menu || !menuList.includes(menu)) {
      navigate("/about?menu=전체보기", { replace: true });
    }

    if (menu && menuList.includes(menu)) {
      setActiveMenu(menu);
    }
  }, [searchParams, menuList, navigate]);


  return (
    <div >
      <MobileSubVisual title="구성원" menuList={menuList} activeMenu={activeMenu} backgroundImage={BackgroundImage} setActiveMenu={handleMenuClick} />
      <MainContent >
        {/* <MobileSubTitle title={activeMenu} /> */}
        <MemberListSection
          activeMenu={activeMenu}
          isMobile
          showTitle={true}
          showSearch
          DetailModalComponent={MobileMemberDetailModal}
          titleOverride={activeMenu}
        />
      </MainContent>
    </div >
  );
}